import {
  addStringNoLocale,
  getSourceUrl,
  addDatetime,
  saveSolidDatasetAt,
  setThing,
  createThing,
  addUrl,
} from "@inrupt/solid-client";
import { useDataset } from "@inrupt/solid-ui-react";
import React, { useState } from "react";
import { Alert, Box, CircularProgress, Typography } from "@mui/material";

import {
  CREATED_PREDICATE,
  QUOTE_CLASS,
  TEXT_PREDICATE,
  TYPE_PREDICATE,
} from "../../lib/predicates";

//TODO: Add optional author or source column for each quote
//TODO: Add only allowed to update if session...
function PublicAddQuote({
  publicQuoteList,
  setPublicQuoteList,
  handlePublicQuoteList,
}) {
  const { dataset, error } = useDataset(
    "https://storage.inrupt.com/0ceecbd1-59d2-4858-8e73-a819d5bdb943/commonplace-book/index.ttl"
  );
  const [quoteText, setQuoteText] = useState("");

  const addQuote = async (text) => {
    const indexUrl = getSourceUrl(dataset);
    const quoteWithText = addStringNoLocale(
      createThing(),
      TEXT_PREDICATE,
      text
    );
    const quoteWithDate = addDatetime(
      quoteWithText,
      CREATED_PREDICATE,
      new Date()
    );
    const quoteWithType = addUrl(quoteWithDate, TYPE_PREDICATE, QUOTE_CLASS);
    const updatedQuoteList = setThing(dataset, quoteWithType);
    const updatedDataset = await saveSolidDatasetAt(indexUrl, updatedQuoteList);
    handlePublicQuoteList(updatedDataset);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    addQuote(quoteText);
    setQuoteText("");
  };
  const handleChange = (e) => {
    e.preventDefault();
    setQuoteText(e.target.value);
  };

  if (error) {
    return (
      <Alert severity="error" sx={{ mb: 1 }}>
        We couldn’t load the communal list yet. You won’t be able to add quotes until it’s available.
      </Alert>
    );
  }
  if (!dataset) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <CircularProgress size={20} />
        <Typography variant="body2">Loading communal list…</Typography>
      </Box>
    );
  }

  return (
    <>
      <form onSubmit={handleSubmit} className="quote-form">
        <label htmlFor="quote-input">
          <input
            id="quote-input"
            type="text"
            value={quoteText}
            onChange={handleChange}
          />
        </label>
        <button type="submit" className="add-button">
          Add Quote
        </button>
      </form>
    </>
  );
}

export default PublicAddQuote;
